import React, { Component } from "react";
import { UilMusicTuneSlash } from "@iconscout/react-unicons";
import { UilMusic } from "@iconscout/react-unicons";

class PlayMusic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false,
    };
  }

  onPlay = (event) => {
    this.setState({ playing: true });
  };
  onPause = (event) => {
    this.setState({ playing: false });
  };
  onEnded = (event) => {
    this.setState({ playing: false });
  };

  playAudio = () => {
    this.audioEl.play();
    const audio = this.audioEl;
    audio.addEventListener("play", this.onPlay);
    audio.addEventListener("pause", this.onPause);
  };

  pauseAudio = () => {
    this.audioEl.pause();
  };

  startAudio = () => {
    this.playAudio();
  };

  renderAudio = () => {
    const { url } = this.props;
    const { playing } = this.state;
    const notSupportedMsg =
      "Your browser does not support the <code>audio</code> element.";
    return (
      <>
        {!playing && (
          <button
            className="button-default relative text-red-600 mt-[40px] ml-[40px] bg-[#d5ffc8] px-3 py-3 border-2 rounded-xl text-2xl font-bold"
            onClick={this.startAudio}
          >
            <UilMusicTuneSlash />
          </button>
        )}
        {playing && (
          <button
            className="button-default relative text-red-600 mt-[40px] ml-[40px] bg-[#d5ffc8] px-3 py-3 border-2 rounded-xl text-2xl font-bold"
            onClick={this.pauseAudio}
          >
            <UilMusic />
          </button>
        )}
        <audio
          src={url}
          ref={(ref) => {
            this.audioEl = ref;
          }}
        >
          {notSupportedMsg}
        </audio>
      </>
    );
  };

  render() {
    return this.renderAudio();
  }
}

export default PlayMusic;
